(function (Drupal, once) {
  Drupal.behaviors.productImages = {
    attach(context) {

      once('productImages', context.querySelectorAll('#product-images'))
      .forEach((element) => {
        const slideCount = element.querySelectorAll('.splide__slide').length;

        const productImagesSlider = new Splide(element, {
          type: 'fade',
          perPage: 1,
          perMove: 1,
          draggable: true,
          pagination: true,
          arrows: true
        });

        // CSS class logic for centering static elements
        if (slideCount >= 2) {
          productImagesSlider.mount();
        }
      });
    }
  };
})(Drupal, once);